import useAppDispatch from "../../redux/base/useAppDispatch";
import { useEffect, useState } from "react";
import { AsyncCallArgs, useAsyncCall } from "@duosoftbg/nacid-components";
import { addObject, removeObject } from "../../../store/redux/slice/IpoView/ipoViewPage";

type ViewObjectControlProps = {
  viewType: string;
  serviceFn: any;
  viewId: string | number;
};

const useViewObjectControl = ({ viewType, serviceFn, viewId }: ViewObjectControlProps) => {
  const dispatch = useAppDispatch();
  const [isLoading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);
  const { asyncCall } = useAsyncCall();

  useEffect(() => {
    if (viewId) {
      const asyncCallArgs: AsyncCallArgs = {
        promise: serviceFn,
        onSuccess: (response) => {
          const payload = { viewType, key: viewId, data: response };
          dispatch(addObject(payload));
          setLoading(false);
        },
        onError: () => {
          setNotFound(true);
          setLoading(false);
        },
      };
      asyncCall(asyncCallArgs);
    } else {
      setLoading(false);
      setNotFound(true);
    }
    return () => {
      dispatch(removeObject());
    };
  }, [asyncCall, dispatch, serviceFn, viewId, viewType]);

  return { isLoading, notFound };
};

export default useViewObjectControl;
